import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    if (typeof localStorage !== 'undefined' && localStorage.getItem('token')) {
      return true;
    }

    return this.router.createUrlTree(['/Signin', 0]);
  }
}
